import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 45;

export const migration_44_45:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'Image' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((property:any) =>
                            {
                                if( property.name === 'model' )
                                {
                                    property._value = {
                                        ...propertyValue,
                                        ...property._value,
                                        hoverState: {
                                            ...propertyValue.hoverState,
                                            ...property._value.hoverState
                                        },
                                        activeState: {
                                            ...propertyValue.activeState,
                                            ...property._value.activeState
                                        }
                                    };
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

const propertyValue = {
    "url": {
        "__type": "STRING",
        "value": "drawings2:photo"
    },
    "color1": {
        "color": {
            "hex": {
                "__type": "STRING",
                "value": "#444f5c"
            },
            "alpha": {
                "__type": "NUMBER",
                "value": 1
            }
        },
        "visibility": {
            "__type": "BOOLEAN",
            "value": true
        }
    },
    "color2": {
        "color": {
            "hex": {
                "__type": "STRING",
                "value": "#3f3d56"
            },
            "alpha": {
                "__type": "NUMBER",
                "value": 1
            }
        },
        "visibility": {
            "__type": "BOOLEAN",
            "value": true
        }
    },
    "backgroundSize": {
        "__type": "STRINGENUM",
        "selectedValue": "cover",
        "values": [
            "auto",
            "contain",
            "cover",
            "100% auto",
            "auto 100%"
        ]
    },
    "horizontalAlign": {
        "__type": "STRINGENUM",
        "selectedValue": "center",
        "values": [
            "left",
            "center",
            "right",
            "justify"
        ]
    },
    "verticalAlign": {
        "__type": "STRINGENUM",
        "selectedValue": "middle",
        "values": [
            "top",
            "middle",
            "bottom",
            "baseline"
        ]
    },
    "background": {
        "type": {
            "__type": "STRINGENUM",
            "selectedValue": "Solid Color",
            "values": [
                "Solid Color",
                "Linear Gradient"
            ]
        },
        "solidColor": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#ffffff"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "gradientFromColor": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#ffffff"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "gradientToColor": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#000000"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "gradientAngle": {
            "__type": "NUMBER",
            "value": 0
        }
    },
    "border": {
        "borderColor": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#000000"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": false
            }
        },
        "borderThickness": {
            "value": {
                "__type": "NUMBER",
                "value": 1
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "borderStyle": {
            "__type": "STRINGENUM",
            "selectedValue": "solid",
            "values": [
                "solid",
                "dashed",
                "dotted"
            ]
        },
        "borderRadius": {
            "topLeft": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "topRight": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "bottomLeft": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "bottomRight": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            }
        },
        "borderFill": {
            "__type": "STRINGENUM",
            "selectedValue": "borderAll",
            "values": [
                "borderLeft",
                "borderTop",
                "borderRight",
                "borderBottom",
                "borderAll"
            ]
        }
    },
    "boxShadow": {
        "color": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#000000"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 0.5
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": false
            }
        },
        "deltaX": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "deltaY": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "blur": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "spread": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        }
    },
    "padding": {
        "top": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "right": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "bottom": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        },
        "left": {
            "value": {
                "__type": "NUMBER",
                "value": 0
            },
            "unitsType": {
                "__type": "STRINGENUM",
                "selectedValue": "px",
                "values": [
                    "px",
                    "%",
                    "auto"
                ]
            }
        }
    },
    "hoverState": {
        "isEnabled": {
            "__type": "BOOLEAN",
            "value": false
        },
        "url": {
            "__type": "STRING",
            "value": "drawings2:photo"
        },
        "color1": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#444f5c"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "color2": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#3f3d56"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "backgroundSize": {
            "__type": "STRINGENUM",
            "selectedValue": "cover",
            "values": [
                "auto",
                "contain",
                "cover",
                "100% auto",
                "auto 100%"
            ]
        },
        "horizontalAlign": {
            "__type": "STRINGENUM",
            "selectedValue": "center",
            "values": [
                "left",
                "center",
                "right",
                "justify"
            ]
        },
        "verticalAlign": {
            "__type": "STRINGENUM",
            "selectedValue": "middle",
            "values": [
                "top",
                "middle",
                "bottom",
                "baseline"
            ]
        },
        "background": {
            "type": {
                "__type": "STRINGENUM",
                "selectedValue": "Solid Color",
                "values": [
                    "Solid Color",
                    "Linear Gradient"
                ]
            },
            "solidColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#ffffff"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientFromColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#ffffff"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientToColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientAngle": {
                "__type": "NUMBER",
                "value": 0
            }
        },
        "border": {
            "borderColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": false
                }
            },
            "borderThickness": {
                "value": {
                    "__type": "NUMBER",
                    "value": 1
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "borderStyle": {
                "__type": "STRINGENUM",
                "selectedValue": "solid",
                "values": [
                    "solid",
                    "dashed",
                    "dotted"
                ]
            },
            "borderRadius": {
                "topLeft": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "topRight": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "bottomLeft": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "bottomRight": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                }
            },
            "borderFill": {
                "__type": "STRINGENUM",
                "selectedValue": "borderAll",
                "values": [
                    "borderLeft",
                    "borderTop",
                    "borderRight",
                    "borderBottom",
                    "borderAll"
                ]
            }
        },
        "boxShadow": {
            "color": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 0.5
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": false
                }
            },
            "deltaX": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "deltaY": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "blur": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "spread": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            }
        },
        "padding": {
            "top": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "right": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "bottom": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "left": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            }
        }
    },
    "activeState": {
        "isEnabled": {
            "__type": "BOOLEAN",
            "value": false
        },
        "url": {
            "__type": "STRING",
            "value": "drawings2:photo"
        },
        "color1": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#444f5c"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "color2": {
            "color": {
                "hex": {
                    "__type": "STRING",
                    "value": "#3f3d56"
                },
                "alpha": {
                    "__type": "NUMBER",
                    "value": 1
                }
            },
            "visibility": {
                "__type": "BOOLEAN",
                "value": true
            }
        },
        "backgroundSize": {
            "__type": "STRINGENUM",
            "selectedValue": "cover",
            "values": [
                "auto",
                "contain",
                "cover",
                "100% auto",
                "auto 100%"
            ]
        },
        "horizontalAlign": {
            "__type": "STRINGENUM",
            "selectedValue": "center",
            "values": [
                "left",
                "center",
                "right",
                "justify"
            ]
        },
        "verticalAlign": {
            "__type": "STRINGENUM",
            "selectedValue": "middle",
            "values": [
                "top",
                "middle",
                "bottom",
                "baseline"
            ]
        },
        "background": {
            "type": {
                "__type": "STRINGENUM",
                "selectedValue": "Solid Color",
                "values": [
                    "Solid Color",
                    "Linear Gradient"
                ]
            },
            "solidColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#ffffff"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientFromColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#ffffff"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientToColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": true
                }
            },
            "gradientAngle": {
                "__type": "NUMBER",
                "value": 0
            }
        },
        "border": {
            "borderColor": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 1
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": false
                }
            },
            "borderThickness": {
                "value": {
                    "__type": "NUMBER",
                    "value": 1
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "borderStyle": {
                "__type": "STRINGENUM",
                "selectedValue": "solid",
                "values": [
                    "solid",
                    "dashed",
                    "dotted"
                ]
            },
            "borderRadius": {
                "topLeft": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "topRight": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "bottomLeft": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                },
                "bottomRight": {
                    "value": {
                        "__type": "NUMBER",
                        "value": 0
                    },
                    "unitsType": {
                        "__type": "STRINGENUM",
                        "selectedValue": "px",
                        "values": [
                            "px",
                            "%",
                            "auto"
                        ]
                    }
                }
            },
            "borderFill": {
                "__type": "STRINGENUM",
                "selectedValue": "borderAll",
                "values": [
                    "borderLeft",
                    "borderTop",
                    "borderRight",
                    "borderBottom",
                    "borderAll"
                ]
            }
        },
        "boxShadow": {
            "color": {
                "color": {
                    "hex": {
                        "__type": "STRING",
                        "value": "#000000"
                    },
                    "alpha": {
                        "__type": "NUMBER",
                        "value": 0.5
                    }
                },
                "visibility": {
                    "__type": "BOOLEAN",
                    "value": false
                }
            },
            "deltaX": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "deltaY": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "blur": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "spread": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            }
        },
        "padding": {
            "top": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "right": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "bottom": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            },
            "left": {
                "value": {
                    "__type": "NUMBER",
                    "value": 0
                },
                "unitsType": {
                    "__type": "STRINGENUM",
                    "selectedValue": "px",
                    "values": [
                        "px",
                        "%",
                        "auto"
                    ]
                }
            }
        }
    }
};
